import { Directive, OnDestroy, OnInit, ElementRef } from '@angular/core';
import { CustomCapitalizePipe } from '../pipes/capitalize.pipe';

@Directive({
    selector: '[ngModel][jhiCapitalize]'
})
export class CustomCapitalizeDirective implements OnInit, OnDestroy {

    constructor(private capitalizePipe: CustomCapitalizePipe, private el: ElementRef) {
    }

    ngOnInit(): void {
        this.el.nativeElement.addEventListener('input', this.listenerFunction.bind(this), true);
    }

    ngOnDestroy(): void {
        this.el.nativeElement.removeEventListener('input', this.listenerFunction);
    }

    listenerFunction(event: any) {
        event.target.value = this.getNormalizedValue(event.target.value);
    }

    getNormalizedValue(value: string): string {
        return this.capitalizePipe.transform(value);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/directives/capitalize.directive.ts